var map = {
	"./BrazilianPortuguese": [
		"e062",
		"chunk-2d22455d"
	],
	"./BrazilianPortuguese.js": [
		"e062",
		"chunk-2d22455d"
	],
	"./BritishEnglish": [
		"318c",
		"chunk-2d0b8eff"
	],
	"./BritishEnglish.js": [
		"318c",
		"chunk-2d0b8eff"
	],
	"./Dutch": [
		"ff76",
		"chunk-2d238495"
	],
	"./Dutch.js": [
		"ff76",
		"chunk-2d238495"
	],
	"./English": [
		"07ec",
		"chunk-2d0a4ddb"
	],
	"./English.js": [
		"07ec",
		"chunk-2d0a4ddb"
	],
	"./French": [
		"06b2",
		"chunk-2d0a498c"
	],
	"./French.js": [
		"06b2",
		"chunk-2d0a498c"
	],
	"./German": [
		"314b",
		"chunk-2d0b8e82"
	],
	"./German.js": [
		"314b",
		"chunk-2d0b8e82"
	],
	"./Italian": [
		"dbdc",
		"chunk-2d229273"
	],
	"./Italian.js": [
		"dbdc",
		"chunk-2d229273"
	],
	"./Japanese": [
		"ad8e",
		"chunk-2d213786"
	],
	"./Japanese.js": [
		"ad8e",
		"chunk-2d213786"
	],
	"./Korean": [
		"db1b",
		"chunk-2d228c45"
	],
	"./Korean.js": [
		"db1b",
		"chunk-2d228c45"
	],
	"./Polish": [
		"90a1",
		"chunk-2d0e4a3d"
	],
	"./Polish.js": [
		"90a1",
		"chunk-2d0e4a3d"
	],
	"./Portuguese": [
		"c464",
		"chunk-2d216ba5"
	],
	"./Portuguese.js": [
		"c464",
		"chunk-2d216ba5"
	],
	"./Russian": [
		"bdd0",
		"chunk-2d21b104"
	],
	"./Russian.js": [
		"bdd0",
		"chunk-2d21b104"
	],
	"./SimpleChinese": [
		"2152",
		"chunk-2d0b1a12"
	],
	"./SimpleChinese.js": [
		"2152",
		"chunk-2d0b1a12"
	],
	"./Spanish": [
		"f25d",
		"chunk-2d22c151"
	],
	"./Spanish.js": [
		"f25d",
		"chunk-2d22c151"
	],
	"./Thai": [
		"1378",
		"chunk-2d0aad79"
	],
	"./Thai.js": [
		"1378",
		"chunk-2d0aad79"
	],
	"./TraditionalChinese": [
		"bad5",
		"chunk-2d21a5c6"
	],
	"./TraditionalChinese.js": [
		"bad5",
		"chunk-2d21a5c6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d2b7";
module.exports = webpackAsyncContext;